<template>
  <UContainer
    :ui="{
      base: 'mx-auto',
      padding: 'px-4 sm:px-6 lg:px-8',
      constrained: 'max-w-[1920px]',
    }"
  >
    <footer class="footer">
      <div class="footer__main">
        <!-- Контакты + соцсети -->
        <div class="footer__col footer__brand">
          <p v-if="institutionStore.institution?.name" class="footer__title">
            {{ institutionStore.institution?.name }}
          </p>

          <ul class="footer__contacts">
            <li v-if="phone">
              <a :href="`tel:${phone}`" class="footer__link">{{ phone }}</a>
            </li>
            <li v-if="email">
              <a :href="`mailto:${email}`" class="footer__link">{{ email }}</a>
            </li>
            <li v-if="workingHours" class="footer__muted">
              Время работы: {{ workingHours }}
            </li>
          </ul>

          <div v-if="branchSelectOptions.length > 1" class="footer__branch">
            <UiKitSelect
              size="sm"
              variant="flat"
              :options="branchSelectOptions"
              :model-value="institutionStore.selectedBranchId"
              @update:model-value="
                (value) => institutionStore.chooseBranch(value == null ? null : Number(value))
              "
            />
          </div>

          <SocialMadia class="footer__social" />
        </div>

        <!-- Документы -->
        <nav class="footer__col">
          <p class="footer__heading">Документы</p>
          <a href="/privacy" target="_blank" class="footer__link">{{ $t('cookie.link') }}</a>
          <a href="/policy" target="_blank" class="footer__link">{{ $t('cookie.link1') }}</a>
          <!-- Отозвать согласие должно быть так же просто, как дать: без этой ссылки
               решение по cookie принималось один раз и навсегда. -->
          <button type="button" class="footer__link footer__link--button" @click="reopenCookieSettings">
            {{ $t('cookie.settings_link') }}
          </button>
        </nav>

        <!-- Реквизиты -->
        <div class="footer__col footer__legal">
          <p class="footer__heading">Реквизиты</p>
          <span v-if="legal?.individual_entrepreneur">{{ legal.individual_entrepreneur }}</span>
          <span v-if="legal?.INN">ИНН: {{ legal.INN }}</span>
          <span v-if="legal?.OGRN">ОГРНИП: {{ legal.OGRN }}</span>
          <span v-if="legal?.legal_address">Адрес: {{ legal.legal_address }}</span>
        </div>
      </div>

      <div class="footer__bottom">
        <p class="footer__copyright">© {{ currentYear }} {{ institutionStore.institution?.name }}. Все права защищены.</p>

        <div class="footer__elysium">
          <span>Сделано в</span>

          <NuxtLink to="https://t.me/OboraDI" target="_blank">

            <svg v-if="isDark" width="100"  viewBox="0 0 300 72" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_2254_2)">
                <path d="M174.955 23.3955V40.5935C174.955 45.3843 170.638 48.2664 166.62 48.2664H158.855H146.492H130.464C126.206 48.2664 122.751 44.8982 122.751 40.7423V23.3955H128.326V40.7423C128.326 41.8923 129.282 42.8262 130.463 42.8262H146.491V42.8235H166.617C168.322 42.8235 169.371 41.6828 169.371 40.5935V38.5346L153.698 38.5412C149.438 38.5412 145.983 35.1756 145.983 31.021V23.3968H151.56V31.021C151.56 32.171 152.516 33.1023 153.695 33.1023L169.37 33.0957V23.3955H174.951H174.955Z" fill="white"/>
                <path d="M215.881 47.8503L215.877 31.3044H221.455L221.458 47.8503H215.881Z" fill="white"/>
                <path d="M221.458 28.8702L188.61 28.8188C187.398 28.8188 186.414 29.7764 186.414 30.9606C186.414 32.1422 187.398 33.1025 188.61 33.1025H202.027C206.322 33.1025 209.803 36.497 209.803 40.6832C209.803 44.872 206.322 48.2666 202.027 48.2666H180.984V42.825H202.027C203.241 42.825 204.223 41.8674 204.223 40.6832C204.223 39.5016 203.241 38.5414 202.027 38.5414H188.61C184.317 38.5414 180.837 35.1468 180.837 30.9606C180.837 26.7744 184.317 23.3799 188.61 23.3799L221.458 23.4313V28.8702Z" fill="white"/>
                <path d="M267.77 30.8683V48.2664H262.189V23.3982H267.784L281.097 35.6644L294.405 23.3982H299.999V48.2664H294.423V30.8683L281.097 43.1476L267.77 30.8683Z" fill="white"/>
                <path d="M256.307 23.3955V40.7423C256.307 44.8969 252.852 48.2664 248.592 48.2664H235.052C230.792 48.2664 227.34 44.8969 227.34 40.7423V23.3955H232.917V40.7423C232.917 41.8923 233.873 42.8235 235.052 42.8235H248.592C249.771 42.8235 250.728 41.8923 250.728 40.7423V23.3955H256.307Z" fill="white"/>
                <path d="M116.712 48.2191L95.508 48.2323C90.8212 48.2323 87.8187 44.6283 87.8187 40.3117C87.9741 36.3007 91.3588 33.0945 95.508 33.0945L116.712 33.1077V38.5347L95.508 38.5215C92.6622 38.5215 92.7054 42.8065 95.508 42.8065L116.712 42.7934V48.2204V48.2191Z" fill="white"/>
                <path d="M116.61 28.7528C109.423 28.7528 102.235 28.6527 95.0482 28.7528C92.952 28.7818 88.5569 29.5155 87.8276 31.8839C87.8316 31.7179 87.8357 31.0936 87.8411 30.9381C87.9869 26.8007 90.6437 23.3245 95.117 23.3245H103.533L116.61 23.3324V28.7528Z" fill="white"/>
                <path d="M60.4292 0H13.0805C5.85635 0 0 5.70348 0 12.7391V58.8518C0 65.8874 5.85635 71.5909 13.0805 71.5909H60.4292C67.6534 71.5909 73.5097 65.8874 73.5097 58.8518V12.7391C73.5097 5.70348 67.6534 0 60.4292 0Z" fill="white"/>
                <path d="M57.2057 32.0205V39.6924L27.1891 39.6729C23.1599 39.6729 23.2207 45.7295 27.1891 45.7295L57.2057 45.709V53.3828L27.1891 53.4023C20.5549 53.4023 16.3024 48.3082 16.3024 42.2041C16.5229 36.5334 21.3137 32.001 27.1891 32.001L57.2057 32.0205ZM57.0631 18.2002V25.8623H57.0612C46.8863 25.8623 36.71 25.7214 26.5378 25.8623C23.5703 25.9031 17.3484 26.9406 16.3151 30.2891C16.3205 30.0548 16.3265 29.1716 16.3346 28.9521C16.5402 23.1023 20.3019 18.1886 26.6344 18.1885H38.5495L57.0631 18.2002Z" fill="#3D5AF1"/>
              </g>
              <defs>
                <clipPath id="clip0_2254_2">
                  <rect width="300" height="71.5909" fill="white"/>
                </clipPath>
              </defs>
            </svg>

            <svg v-else width="100"  viewBox="0 0 300 72" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_2254_21)">
                <path d="M174.955 23.3955V40.5935C174.955 45.3843 170.638 48.2664 166.62 48.2664H158.855H146.492H130.464C126.206 48.2664 122.751 44.8982 122.751 40.7423V23.3955H128.326V40.7423C128.326 41.8923 129.282 42.8262 130.463 42.8262H146.491V42.8235H166.617C168.322 42.8235 169.371 41.6828 169.371 40.5935V38.5346L153.698 38.5412C149.438 38.5412 145.983 35.1756 145.983 31.021V23.3968H151.56V31.021C151.56 32.171 152.516 33.1023 153.695 33.1023L169.37 33.0957V23.3955H174.951H174.955Z" fill="#4965F2"/>
                <path d="M215.881 47.8503L215.877 31.3044H221.455L221.458 47.8503H215.881Z" fill="#4965F2"/>
                <path d="M221.458 28.8702L188.61 28.8188C187.398 28.8188 186.414 29.7764 186.414 30.9606C186.414 32.1422 187.398 33.1025 188.61 33.1025H202.027C206.322 33.1025 209.803 36.497 209.803 40.6832C209.803 44.872 206.322 48.2666 202.027 48.2666H180.984V42.825H202.027C203.241 42.825 204.223 41.8674 204.223 40.6832C204.223 39.5016 203.241 38.5414 202.027 38.5414H188.61C184.317 38.5414 180.837 35.1468 180.837 30.9606C180.837 26.7744 184.317 23.3799 188.61 23.3799L221.458 23.4313V28.8702Z" fill="#4965F2"/>
                <path d="M267.77 30.8683V48.2664H262.189V23.3982H267.784L281.097 35.6644L294.405 23.3982H299.999V48.2664H294.423V30.8683L281.097 43.1476L267.77 30.8683Z" fill="#4965F2"/>
                <path d="M256.307 23.3955V40.7423C256.307 44.8969 252.852 48.2664 248.592 48.2664H235.052C230.792 48.2664 227.34 44.8969 227.34 40.7423V23.3955H232.917V40.7423C232.917 41.8923 233.873 42.8235 235.052 42.8235H248.592C249.771 42.8235 250.728 41.8923 250.728 40.7423V23.3955H256.307Z" fill="#4965F2"/>
                <path d="M116.712 48.2191L95.508 48.2323C90.8212 48.2323 87.8187 44.6283 87.8187 40.3117C87.9741 36.3007 91.3588 33.0945 95.508 33.0945L116.712 33.1077V38.5347L95.508 38.5215C92.6622 38.5215 92.7054 42.8065 95.508 42.8065L116.712 42.7934V48.2204V48.2191Z" fill="#4965F2"/>
                <path d="M116.61 28.7528C109.423 28.7528 102.235 28.6527 95.0482 28.7528C92.952 28.7818 88.5569 29.5155 87.8276 31.8839C87.8316 31.7179 87.8357 31.0936 87.8411 30.9381C87.9869 26.8007 90.6437 23.3245 95.117 23.3245H103.533L116.61 23.3324V28.7528Z" fill="#4965F2"/>
                <path d="M60.4292 0H13.0805C5.85635 0 0 5.70348 0 12.7391V58.8518C0 65.8874 5.85635 71.5909 13.0805 71.5909H60.4292C67.6534 71.5909 73.5097 65.8874 73.5097 58.8518V12.7391C73.5097 5.70348 67.6534 0 60.4292 0Z" fill="url(#paint0_linear_2254_21)"/>
                <path d="M57.2057 32.0205V39.6924L27.1891 39.6729C23.1599 39.6729 23.2207 45.7295 27.1891 45.7295L57.2057 45.709V53.3828L27.1891 53.4023C20.5549 53.4023 16.3024 48.3082 16.3024 42.2041C16.5229 36.5334 21.3137 32.001 27.1891 32.001L57.2057 32.0205ZM57.0631 18.2002V25.8623H57.0612C46.8863 25.8623 36.71 25.7214 26.5378 25.8623C23.5703 25.9031 17.3484 26.9406 16.3151 30.2891C16.3205 30.0548 16.3265 29.1716 16.3346 28.9521C16.5402 23.1023 20.3019 18.1886 26.6344 18.1885H38.5495L57.0631 18.2002Z" fill="url(#paint1_linear_2254_21)"/>
              </g>
              <defs>
                <linearGradient id="paint0_linear_2254_21" x1="-65.2021" y1="-40.7671" x2="59.0367" y2="68.5506" gradientUnits="userSpaceOnUse">
                  <stop stop-color="white"/>
                  <stop offset="1" stop-color="#3D5AF1"/>
                </linearGradient>
                <linearGradient id="paint1_linear_2254_21" x1="44.7054" y1="34.2475" x2="-1.19612" y2="33.8046" gradientUnits="userSpaceOnUse">
                  <stop stop-color="#FEFEFE"/>
                  <stop offset="1" stop-color="#8597F6"/>
                </linearGradient>
                <clipPath id="clip0_2254_21">
                  <rect width="300" height="71.5909" fill="white"/>
                </clipPath>
              </defs>
            </svg>
          </NuxtLink>
        </div>
      </div>
    </footer>
  </UContainer>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import dayjs from 'dayjs';
import { useInstitutionStore } from '@entities/institution';
import { useDarkMode, useCookieConsent } from '@shared/lib';

const { isDark } = useDarkMode();
const { reopen: reopenCookieSettings } = useCookieConsent();
const currentYear = dayjs().year();
const institutionStore = useInstitutionStore()

// Опции выбора филиала для UiKitSelect: { label: «Город, Улица», value: id }
const branchSelectOptions = computed(() =>
  institutionStore.branchOptions.map((o) => ({ label: o.label, value: o.id })),
)

const legal = computed(() => institutionStore.institution?.legal_information)
const phone = computed(() => institutionStore.currentCity?.phone)
const workingHours = computed(() => institutionStore.currentCity?.working_hours?.hours)
const email = computed(
  () => legal.value?.email || institutionStore.institution?.legal_information_email,
)
</script>

<style scoped lang="scss">
.footer {
  @apply py-10 border-t border-gray-200 dark:border-zinc-700;

  &__main {
    @apply grid gap-10 sm:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1.6fr];
  }

  &__col {
    @apply flex flex-col gap-2.5 items-start;
  }

  &__title {
    @apply text-base font-semibold text-gray-900 dark:text-white;
  }

  &__heading {
    @apply text-xs font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500 mb-1;
  }

  &__contacts {
    @apply flex flex-col gap-1.5;
  }

  &__link {
    @apply text-sm text-gray-600 dark:text-gray-300 transition-colors hover:text-sky-600 dark:hover:text-sky-400;

    // Ссылка «Настройки cookie» — это кнопка (перезапускает баннер, а не ведёт на URL),
    // но в колонке документов должна выглядеть ровно так же, как соседние ссылки.
    &--button {
      @apply text-left bg-transparent p-0 cursor-pointer;
    }
  }

  &__muted {
    @apply text-sm text-gray-400 dark:text-gray-500;
  }

  &__legal {
    @apply text-xs leading-relaxed text-gray-400 dark:text-gray-500;
  }

  &__branch {
    @apply w-full max-w-[340px] mt-1;
  }

  &__social {
    @apply mt-2 justify-start;
  }

  &__bottom {
    @apply mt-10 pt-6 border-t border-gray-100 dark:border-zinc-800
           flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between;
  }

  &__copyright {
    @apply text-xs text-gray-400 dark:text-gray-500;
  }

  &__elysium {
    @apply flex items-center gap-2 text-xs text-gray-400 dark:text-gray-500;
  }

  path {
    @apply dark:fill-white;
  }
}
</style>
